<h2 mat-dialog-title>Next {{ data }} not found</h2>
<mat-dialog-content>Select a sequence from the calendar or <span class="text-button text-base"
    (click)="onSearchClick()">search
    flights</span>.</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close tabindex="-1">Close</button>
</mat-dialog-actions>